import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            // Quick Links
            gsap.to(".human-resources .quick-links .page-title", {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".human-resources .quick-links",
                    start: "top bottom-=100",
                }
            })
          
            gsap.to(".human-resources .quick-links p", {
                autoAlpha: 1,
                y: 0,
                delay: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".human-resources .quick-links",
                    start: "top bottom-=100",
                }
            })

            gsap.to(".human-resources .quick-links .page-title > span", {
                scale: 1,
                delay: 0.1,
                duration: 0.8,
                ease: defaultEase,

                scrollTrigger: {
                    trigger: ".human-resources .quick-links",
                    start: "top bottom-=100",
                }
            })

            $(".human-resources .quick-links .quick-link-item").each(function () {
                gsap.to($(this), {
                    autoAlpha: 1,
                    y: 0,
                    delay: 0.2,
                    duration: 0.8,
                    ease: defaultEase,

                    scrollTrigger: {
                        start: $(this).offset().top + " bottom-=100",
                    }
                })
            })
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });
})